import { useCallback, useEffect, useRef, useState } from 'react';
import { useInspecao } from '@/features/painel-tecnico/registro';
import { ErroDaGeoEngine } from '@/services/geo-engine/errors';
/** Estado de uma chamada à Geo-Engine: carregamento, erro e alimentação do painel técnico. */
export function useChamada() {
    const { registrar } = useInspecao();
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState(null);
    const controlador = useRef(null);
    const montado = useRef(true);
    useEffect(() => {
        montado.current = true;
        return () => {
            montado.current = false;
            controlador.current?.abort();
        };
    }, []);
    const executar = useCallback(async (operacao) => {
        // Uma chamada por vez neste hook: a anterior é abortada para não sobrescrever o resultado atual.
        controlador.current?.abort();
        const atual = new AbortController();
        controlador.current = atual;
        setCarregando(true);
        setErro(null);
        try {
            const { dados, registro } = await operacao(atual.signal);
            registrar({ registro, erro: null });
            return dados;
        }
        catch (falha) {
            if (atual.signal.aborted) {
                return null;
            }
            if (falha instanceof ErroDaGeoEngine) {
                registrar({
                    registro: falha.registro,
                    erro: { codigo: falha.codigo, mensagem: falha.message },
                });
                if (montado.current) {
                    setErro(falha);
                }
                return null;
            }
            throw falha;
        }
        finally {
            if (montado.current && controlador.current === atual) {
                setCarregando(false);
            }
        }
    }, [registrar]);
    const limparErro = useCallback(() => setErro(null), []);
    return { executar, carregando, erro, limparErro };
}
